import { LengthUnits } from "./LengthUnits";
import { UnitConversionFactor } from "./UnitConversionFactor";
import { UnitConversionFactorGroup } from "./UnitConversionFactorGroup";

export class LengthConversionFactors {
    public static readonly FT_TO_IN =
        new UnitConversionFactor(12.0, LengthUnits.FOOT, LengthUnits.INCH);
    public static readonly FT_TO_M =
        new UnitConversionFactor(0.3048, LengthUnits.FOOT, LengthUnits.METER);

    public static readonly IN_TO_FT =
        new UnitConversionFactor(0.08333333, LengthUnits.INCH, LengthUnits.FOOT);
    public static readonly IN_TO_M =
        new UnitConversionFactor(0.0254, LengthUnits.INCH, LengthUnits.METER);

    public static readonly M_TO_FT =
        new UnitConversionFactor(3.28084, LengthUnits.METER, LengthUnits.FOOT);
    public static readonly M_TO_IN =
        new UnitConversionFactor(39.37008, LengthUnits.METER, LengthUnits.INCH);

    private static readonly group = new UnitConversionFactorGroup(this.FT_TO_IN, this.FT_TO_M, this.IN_TO_FT,
        this.IN_TO_M, this.M_TO_FT, this.M_TO_IN);

    public static get(): UnitConversionFactorGroup {
        return this.group;
    }
}
